import React from 'react';
import {Provider} from 'react-redux';
import {Dashboard} from './Dashboard';
import {store} from './store';

export function DrilldownDashboardContainer() {
  return (
      <Provider store={store}>
        <Dashboard />
      </Provider>
  );
}
